import React from 'react';
import SideMenuIssueDate, {menuItemIssueDate} from '../../components/SideMenuIssueDate/SideMenuIssueDate';

import { useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import '../DocumentationTeamHealth/DocTeamHealth.css'

const GettingStarted = () => {
    const [inactive, setInactive] = useState(false);

    return (
      <>
      			
<div style={{marginTop : "30px"}} >
           <SideMenuIssueDate
            onCollapse={(inactive) => {
              //console.log(inactive);
              setInactive(inactive);
            }}
          />

          <div className={`container ${inactive ? "inactive" : ""}`}>

            {/* improvememt, not recorded in video, its just looping through menuItemIssueDate
            instead of hard coding all the routes */}
            {menuItemIssueDate.map((menu, index) => (
              <>
                <Route key={menu.name} exact={menu.exact} path={menu.to}>
               

                  <p>Issue dates overview  documentation</p> 


                  <h1 >Getting started</h1>

                  <h3>1.Introduction </h3>
                  <p>Issue dates overview :  monitor issues creation and due date from different project on aggregated board.</p>

                  <h3>2.Installing</h3>

                  <ol>                    
                    <li >Log into your Confluence instance as an admin.</li>
                    <li>Click the admin dropdown and choose Apps. </li>
                    <li>Locate Issue dates overview.</li>
                    <li>Click Free trial to download and install your app.</li>
                    <li>Click Close in the Installed and ready to go dialog.</li>                   
                  </ol>     
                                 


                  <h3>2.Add Issue dates overview gadget to Jira dashboard</h3>

                  <ul>
                    <li>Find Issue dates overview in the Gadgets Directory and click "Add gadget"</li>
                  </ul>

                  <h3>3.Configure Issue dates overview options</h3>
                  <p>Issue dates overview pretty simple to configure only 2 steps are required :</p>
                  <ul>
                
                    <li style={{marginLeft:"6%"}}>	Name : Give  a name for the part you want monitor </li>

                    <li style={{marginLeft:"6%"}}>	<p>Use simple JQL statement to precise the  type of issues you want to display on which project or sprint 
                    for example : ( issuetype = Story AND project = Demo_1 )
                    Click Save , in this case the gadget will display to you a diagram of time contains issues with the type Story on Project Demo_1 with their  Creation and due date
                    another example : (issuetype = Story AND issuetype = Task  AND project = Demo_1 ) 
                    in this case the gadget will display to you a diagram of time contains issues with the type Story  and Task on Project Demo_1 with their  Creation and due date.</p>
                    </li>
                   
                    <h4 style={{ margin:"10px" }}>Configuration :</h4>
                    <img style={{ margin:"10px", width:"70%"}} src="./assets/configIssueDate.jpeg" alt="img1" width="90%" height="90%"/> 
                   
                    <h4 style={{ margin:"10px" }}>Diagram :</h4> 
                    <img style={{ margin:"10px",width:"70%"}} src="./assets/diagram.jpeg" alt="img1" width="90%" height="90%"/>  

                    <p>- You can visualize multiple Projects or Sprints or both on the same diagram by click on “new “button , a new fields will appears and you repeat the same steps .</p>               
                    
                    <h4 style={{ margin:"10px" }} >Configuration multiple projects :</h4>
                    <img style={{ margin:"10px",width:"70%"}} src="./assets/configMultiple.jpeg" alt="img1" width="90%" height="90%"/>  
                    
                    <h4 style={{ margin:"10px" }} >Diagram multiple projects :</h4>
                    <img style={{ margin:"10px",width:"70%"}} src="./assets/DiagramMultiple.jpeg" alt="img1" width="90%" height="90%"/>  


                    

                    
                   

                  </ul>  
                  {/*   
                  <button style={{
                    backgroundColor: "green",
                    border: "none",
                    color: "white",
                    padding: "15px 32px",
                    textAlign: "center",
                    textDecoration: "none",
                    display: "inline-block",
                    fontSize: "16px",
                    margin: "4px 2px",
                    cursor: "pointer",
                    borderRadius: "10px",
                  }}>Next</button>
                 */}

                 
                 
  
  
                </Route>
                {menu.subMenus && menu.subMenus.length > 0
                  ? menu.subMenus.map((subMenu, i) => (
                      <Route key={subMenu.name} path={subMenu.to}>
                        <h1>{subMenu.name}</h1>
                      </Route>
                    ))
                  : null}
              </>
            ))}
             
  
            {/* <Switch>
              <Route exact path={"/"}>
                <Dashboard />
              </Route>
              <Route exact path={"/content"}>
                <Content />
              </Route>
              <Route path={"/content/courses"}>
                <Courses />
              </Route>
              <Route path={"/content/videos"}>
                <Videos />
              </Route>
              <Route path={"/design"}>
                <Design />
              </Route>
              <Route exact path={"/content-2"}>
                <Content2 />
              </Route>
              <Route path={"/content-2/courses"}>
                <Courses2 />
              </Route>
              <Route path={"/content-2/videos"}>
                <Videos2 />
              </Route>
              <Route path={"/design-2"}>
                <Design2 />
              </Route>
            </Switch> */}
           
          </div>
</div>
      </>
      
    )

};

export default GettingStarted;
